import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/en/services/clinical-solutions/clinical-quality-services")({
  head: () => buildRouteHead("/en/services/clinical-solutions/clinical-quality-services"),
  component: ClinicalOffering,
});

